/**
 * Created by lid3ip9 on 07/06/2017.
 */
module.exports = ['$scope', '$http','sessionData', function($scope, $http, sessionData) {

    $scope.custom = true;
    $scope.eliteUser=false;

    $scope.goToSite = function(theTarget, isHref) {
        $scope.myCloseModal();
        if (isHref) {
            window.open(theTarget);

        }
    }
    $scope.myCloseModal = function() {
        this.closeModal();
    }
var  checkBrand=["hmbcbsde","highmarkbcbsde","de","6004","9011","9012","hmbcbswv","ms","highmarkbcbswv","mbh:wv","9009","6003", "9010",
"hmbcbs","hbcbs","highmarkbcbs","6001","9001","hbs","pbs","hmbs","6002","highmarkblueshield","wv","hmny","neny","wny","9017","9018","6014"
]

if(checkBrand.indexOf(sessionData.employerInfo.brandName>-1))
{
    
    $scope.eliteUser=true;
}
}];